import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Button } from '../../../../../components/CiscoUi';
import styles from '../VisibilityFilter.module.css';

export type AccordionButtonProps = {
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
  filtersCount: number;
};

export const AccordionButton = ({
  isOpen,
  setIsOpen,
  filtersCount,
}: AccordionButtonProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <Button
      className="accordion__title btn btn--link"
      onClick={() => setIsOpen(!isOpen)}
    >
      <span
        className={classNames(styles.heading, {
          [styles.headingOpen]: isOpen,
        })}
      >
        {t('templateManager.filters.heading')}
      </span>
      <span className={styles.count}>
        {filtersCount
          ? `(${filtersCount} ${t('templateManager.filters.applied')})`
          : null}
      </span>

      <span className="accordion__toggle icon-chevron-down"></span>
    </Button>
  );
};
